import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sharePoint = defineConnector({
  identifier: "sharePoint",
  name: "Microsoft SharePoint",
  tagLine: "Document management and collaboration",
  keywords: "spo office 365 m365 graph sites document libraries intranet",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://graph\\.microsoft\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an app in Microsoft Entra ID",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Azure portal](https://portal.azure.com) → **Microsoft Entra ID** → **App registrations** → **New registration**. Single tenant is fine; no redirect URI is needed.",
        },
        {
          kind: "markdown",
          content:
            "Under **API permissions**, add **Microsoft Graph** → **Application** permissions for the SharePoint sites you need (e.g., `Sites.Selected`, `Sites.Read.All`, or `Sites.ReadWrite.All`), then click **Grant admin consent**.",
        },
        {
          kind: "markdown",
          content:
            "Under **Certificates & secrets**, create a new client secret and copy the **Value** (not the Secret ID).",
        },
      ],
    },
    {
      title: "Enter your tenant and app credentials",
      items: [
        {
          kind: "input",
          label: "Directory (tenant) ID",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
          helperText: "From the Azure app overview page.",
        },
        {
          kind: "input",
          label: "Application (client) ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenantId }) =>
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["https://graph.microsoft.com/.default"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.microsoft.com/v1.0/sites/root",
  },
});
